module.exports = __webpack_public_path__ + "img/store_vip_benefit_ok.8877ad55.png";